module.exports = __webpack_public_path__ + "static/img/7.5bd8532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/7.jpg
// module id = dO+U
// module chunks = 0